(function() {
    angular
        .module("app")
        .controller("WzQwsConfigureOutputController", WzQwsConfigureOutputController)

    WzQwsConfigureOutputController.$inject = [
        "$rootScope",
        "$scope",
        "$uibModalInstance",
        "device",
        "wz",
        "config",
        "cancel",
        "saveConfig"
    ]

    function WzQwsConfigureOutputController(
        $rootScope,
        $scope,
        $uibModalInstance,
        device,
        wz,
        config,
        cancel,
        saveConfig
    ){
        "use strict"

        $scope.wz = wz

        const BLANK_MESSAGE_STRINGS = [["", "", ""]]

        const isDefined = (value) => {
            return value !== undefined && value !== null
        }
        $scope.isDefined = isDefined

        const isString = (value) => {
            return typeof value === "string" && value.trim() !== ""
        }

        const isObject = (value) => {
            return Object.prototype.toString.call(value) === "[object Object]"
        }

        const originalConfig = config

        $scope.device             = device
        $scope.config             = JSON.parse(JSON.stringify(config))
        $scope.configIsModified   = false
        $scope.configIsValid      = true
        $scope.outputIsActive     = device.enabled && device.active
        $scope.hasTriggers        = false
        $scope.showConfirmCancel  = false
        $scope.removeInputIndex   = -1

        $scope.popupOrigin = {
            x: 200,
            y: 200
        }

        const checkConfig = () => {

            $scope.configIsModified = !$rootScope.equivalent2($scope.config, originalConfig)

            $scope.hasTriggers    = false
            $scope.outputIsActive = false
            $scope.configIsValid  = true

            for (const input of $scope.config.inputs) {

                if (!$scope.hasTriggers && input.triggers.length > 0) {
                    $scope.hasTriggers = true
                }

                if (!$scope.outputIsActive && (isDefined(input.alert) || input.triggers.length > 0)) {
                    $scope.outputIsActive = true
                }

                if ($scope.configIsValid && isDefined(input.alert) && !isString(input.alert.description)) {
                    $scope.configIsValid = false
                }
            }
        }

        checkConfig()

        const setPopupPosition = (currentTarget) => {

            $scope.popupOrigin = {
                x: 200,
                y: 200
            }

            if (isDefined(currentTarget)) {

                const modalBody = document.getElementById("modal-body-id")

                if (isDefined(modalBody)) {

                    const modalContent = modalBody.parentElement

                    if (isDefined(modalContent)) {

                        const contentRect = modalContent.getBoundingClientRect()

                        if (Object.prototype.toString.call(contentRect) === "[object DOMRect]" && isDefined(contentRect.x) && isDefined(contentRect.y)) {

                            const buttonRect = currentTarget.getBoundingClientRect()

                            if (Object.prototype.toString.call(buttonRect) === "[object DOMRect]" && isDefined(buttonRect.x) && isDefined(buttonRect.y)) {

                                $scope.popupOrigin = {
                                    x: Math.floor(buttonRect.x) - Math.floor(contentRect.x),
                                    y: Math.floor(buttonRect.y) - Math.floor(contentRect.y)
                                }
                            }
                        }
                    }
                }
            }
        }

        const positionPopup = (elementID) => {

            setTimeout(() => {

                $scope.$apply(() => {

                    const popup = document.getElementById(elementID)

                    if (isDefined(popup)) {
                        popup.style.top    = String($scope.popupOrigin.y) + "px"
                        popup.style.left   = String($scope.popupOrigin.x) + "px"
                        popup.style.zIndex = 99
                    }
                })
            }, 10)
        }

        const resetPopup = (elementID) => {

            const popup = document.getElementById(elementID)

            if (isDefined(popup)) {
                popup.style.zIndex = -99
            }
        }

        //
        // Inputs
        //

        $scope.addInput = (input, availIndex) => {

            const newInput = {
                id:                 input.id,
                name:               input.name,
                upstream_proximity: $scope.config.inputs.length + 1,
                triggers: []
            }

            $scope.config.inputs.push(newInput)

            $scope.config.available_inputs = $scope.config.available_inputs.slice(0, availIndex).concat($scope.config.available_inputs.slice(availIndex + 1))

            checkConfig()

        }

        $scope.removeInput = (event, inputIndex) => {

            if (isObject(event) && isDefined(event.currentTarget)) {
                setPopupPosition(event.currentTarget)
            }

            $scope.removeInputIndex = inputIndex

            positionPopup("remove-input-popup")

        }

        $scope.cancelRemoveInput = () => {

            resetPopup("remove-input-popup")

            $scope.removeInputIndex = -1

        }

        $scope.confirmRemoveInput = () => {

            resetPopup("remove-input-popup")

            const inputIndex = $scope.removeInputIndex
            $scope.removeInputIndex = -1

            if (inputIndex < 0) { return }

            if (inputIndex < $scope.config.inputs.length) {

                const input = $scope.config.inputs[inputIndex]

                $scope.config.available_inputs.push({ id: input.id, name: input.name })
                $scope.config.available_inputs = $scope.config.available_inputs.sort((a, b) => { return a.name > b.name ? 1 : -1 })

                $scope.config.inputs = $scope.config.inputs.slice(0, inputIndex).concat($scope.config.inputs.slice(inputIndex + 1))

                checkConfig()

            }
        }

        //
        // Triggers
        //

        $scope.addTrigger = (input) => {

            if (input.triggers.length < 5) {

                let newSpeed = 45

                if (input.triggers.length > 0) {

                    const lastTrigger = input.triggers[input.triggers.length - 1]

                    newSpeed = Math.max(1, lastTrigger.speed - 1)

                    if (lastTrigger.speed >= 6) {
                        newSpeed = lastTrigger.speed - 5
                    }
                }

                const newTrigger = {
                    speed:           newSpeed,
                    message_strings: JSON.parse(JSON.stringify(BLANK_MESSAGE_STRINGS))
                }

                input.triggers.push(newTrigger)

                // TODO: scroll to end of container div?

                checkConfig()

            }
        }

        $scope.removeTrigger = (input, triggerIndex) => {

            if (triggerIndex < input.triggers.length) {

                input.triggers = input.triggers.slice(0, triggerIndex).concat(input.triggers.slice(triggerIndex + 1))

                checkConfig()

            }
        }

        //
        // Message Page
        //

        $scope.addMessagePage = (input, trigger) => {

            let messageStrings = undefined

            if (input === -1) { // Free Flow Message

                messageStrings = $scope.config.message_strings

            } else if (isDefined($scope.config.inputs[input]) && isDefined($scope.config.inputs[input].triggers[trigger])) {

                messageStrings = $scope.config.inputs[input].triggers[trigger].message_strings

            }

            if (isDefined(messageStrings) && messageStrings.length < 4) {
                messageStrings.push(["", "", ""])
                checkConfig()
            }
        }

        $scope.removeMessagePage = (input, trigger, page) => {

            if (input === -1) { // Free Flow Message

                const messageStrings = $scope.config.message_strings

                if (messageStrings.length > 1) {

                    if (page < messageStrings.length) {

                        const newMessageStrings = messageStrings.slice(0, page).concat(messageStrings.slice(page + 1))
                        $scope.config.message_strings = newMessageStrings
                        checkConfig()

                    }
                }

            } else if (isDefined($scope.config.inputs[input]) && isDefined($scope.config.inputs[input].triggers[trigger])) {

                const messageStrings = $scope.config.inputs[input].triggers[trigger].message_strings

                if (isDefined(messageStrings)) {

                    const newMessageStrings = messageStrings.slice(0, page).concat(messageStrings.slice(page + 1))
                    $scope.config.inputs[input].triggers[trigger].message_strings = newMessageStrings
                    checkConfig()

                }
            }
        }

        //
        // Alerts
        //

        $scope.createAlert = (input) => {

            if (isDefined(input.alert)) { return }

            input.alert = {
                level:            "Critical",
                cooldown_minutes: "60",
                description:      "",
                speed:            45
            }

            checkConfig()

        }

        $scope.deleteAlert = (input) => {

            delete input.alert

            checkConfig()

        }

        //
        // Upstream Proximity
        //

        $scope.moveInputUp = (index) => {

            const thisInput  = $scope.config.inputs[index]
            const otherInput = $scope.config.inputs[index - 1]

            if (isDefined(thisInput) && isDefined(otherInput)) {

                thisInput.upstream_proximity  = thisInput.upstream_proximity  - 1
                otherInput.upstream_proximity = otherInput.upstream_proximity + 1

                $scope.config.inputs.sort((a, b) => { return a.upstream_proximity < b.upstream_proximity ? -1 : 1 })

                checkConfig()

            }
        }

        $scope.moveInputDown = (index) => {

            const thisInput  = $scope.config.inputs[index]
            const otherInput = $scope.config.inputs[index + 1]

            if (isDefined(thisInput) && isDefined(otherInput)) {

                thisInput.upstream_proximity  = thisInput.upstream_proximity  + 1
                otherInput.upstream_proximity = otherInput.upstream_proximity - 1

                $scope.config.inputs.sort((a, b) => { return a.upstream_proximity < b.upstream_proximity ? -1 : 1 })

                checkConfig()

            }
        }

        //
        // Input Value Validation
        //

        $scope.onChangeInputValue = () => {
            checkConfig()
        }

        //
        // Input Value Validation - Speeds
        //

        const _normalizeSpeed = (value) => {

            if (isString(value) || value < 1) { return 1 }
            if (value > 255 )                 { return 255 }
            return value

        }

        $scope.onChangeAlertSpeed = (alert) => {

            alert.speed = _normalizeSpeed(alert.speed)

            checkConfig()

        }

        let _sortTriggers = undefined

        $scope.onChangeTriggerSpeed = (input, trigger, inputIndex, triggerIndex) => {

            trigger.speed = _normalizeSpeed(trigger.speed)

            clearTimeout(_sortTriggers)

            _sortTriggers = setTimeout(() => {

                $scope.$apply(() => {

                    const element = document.getElementById("trigger-" + String(inputIndex) + "-" + String(triggerIndex))

                    if (isDefined(element)) {
                        element.blur()
                    }

                    input.triggers.sort((a, b) => { return a.speed > b.speed ? -1 : 1 })

                    checkConfig()

                })

            }, 1250)
        }

        //
        // Modal Control
        //

        $scope.cancel = (event) => {

            resetPopup("cancel-config-popup")

            if ($scope.configIsModified) {

                if (isObject(event) && isDefined(event.currentTarget)) {
                    setPopupPosition(event.currentTarget)
                }

                $scope.showConfirmCancel = true

                positionPopup("cancel-config-popup")

            } else {

                $scope.confirmCancel()

            }
        }

        $scope.cancelCancel = () => {
            $scope.showConfirmCancel = false
        }

        $scope.confirmCancel = () => {
            cancel()
            $uibModalInstance.dismiss("cancel")
        }

        $scope.save = () => {

            checkConfig()

            if (!$scope.configIsModified) {

                $uibModalInstance.dismiss("cancel")

            } else if ($scope.configIsValid) {

                $uibModalInstance.close(saveConfig($scope.config))

            }
        }
    }
})()
